import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["output", "input"];
  // connect() {
  //   console.log("In place editing here", this.element)
  // }

  // Method to switch from output to input mode
  edit() {
    this.outputTarget.classList.add("d-none");
    this.inputTarget.classList.remove("d-none");
    const inputElement = this.inputTarget.querySelector("input, textarea, select");
    if (inputElement) {
      inputElement.focus();
    }
  }

  // Method to cancel the edit
  cancel() {
    this.outputTarget.classList.remove("d-none");
    this.inputTarget.classList.add("d-none");
  }

  // Method to save the edited value
  save(event) {
    event.preventDefault();
    event.stopPropagation();

    const url = this.data.get("url");
    const field = this.data.get("field");

    let value;
    const inputElement = this.inputTarget.querySelector("input");
    const textareaElement = this.inputTarget.querySelector("textarea");
    const selectElement = this.inputTarget.querySelector("select");

    if (textareaElement) {
      value = textareaElement.value;
    } else if (inputElement) {
      value = inputElement.value;
    } else if (selectElement) {
      value = selectElement.value;
    }

    const requestBody = {
      [field]: value,
    };

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.getMetaValue("csrf-token"),
      },
      body: JSON.stringify(requestBody),
    })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          // Check if the response is empty (e.g., 204 No Content)
          if (response.status === 204 || response.headers.get('content-length') === '0') {
            return {}; // Return an empty object for no content
          }

          // Attempt to parse the JSON
          return response.json();
        })
        .then((data) => {
          this.outputTarget.innerHTML = data.new_value ? data.new_value : value;
          // console.log("======== InPlaceController -- data:", data);
          // console.log("======== InPlaceController -- new_value:", data.new_value);
          // console.log("======== InPlaceController -- value:", value);

          const existingCheck = this.outputTarget.parentNode.querySelector('.check-mark');
          if (existingCheck) {
            existingCheck.remove();
          }

          const checkMark = document.createElement('span');
          checkMark.classList.add('check-mark');
          checkMark.innerHTML = ' <i class="fas fa-check"></i>';

          this.outputTarget.parentNode.appendChild(checkMark);
          this.cancel();
        })
        .catch((error) => {
          console.error("======== InPlaceControllerError:", error);
          alert("Failed to save the data. Please try again.");
        });
  }

  // Method to handle selection in dropdowns or similar UI
  selectOption(event) {
    const span = event.target;
    event.stopPropagation();
    this.inputTarget.querySelectorAll("span[data-value]").forEach((s) => {
      s.removeAttribute("data-selected");
    });
    span.setAttribute("data-selected", "true");
  }

  // Helper method to get meta values
  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`);
    return element ? element.getAttribute("content") : null;
  }
}
